import { render, staticRenderFns } from "./index.vue?vue&type=template&id=031975a1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=031975a1&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=031975a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031975a1",
  null
  
)

export default component.exports